import Icon from '../Icon/Icon';

// TODO: Replace with the correct brand back icon once provided by design.
const ChevronLeftIcon = ({className}: {className?: string}) => (
    <Icon width='44' height='44' fill='none' className={className}>
        <rect width='44' height='44' rx='22' fill='#1C1C1D' />
        <path d='M24.8978 14L17.129 21.7419' stroke='#FFFDFB' strokeWidth='1.5' strokeLinecap='round' />
        <path d='M17.129 21.7419L24.8978 29.5107' stroke='#FFFDFB' strokeWidth='1.5' strokeLinecap='round' />
    </Icon>
);

export default ChevronLeftIcon;
